import React from "react";
import { ClientConfig } from "../api";

export interface ClientConfigContextValue {
  clientConfig: ClientConfig;
  webSocketUrl: () => string;
  privacyPolicyUrl: () => string;
  termsOfUseUrl: () => string;
  staticUrl: () => string;
}

export const ClientConfigContext =
  React.createContext<ClientConfigContextValue>(null!);
